/* yargs/lib/decamelize */ function _(require, module, exports) {
    module.exports = (text, separator) => {
        separator = typeof separator === 'undefined' ? '_' : separator;
        return text
            .replace(/([a-z\d])([A-Z])/g, `$1${separator}$2`)
            .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, `$1${separator}$2`)
            .toLowerCase();
    };
}
